import React, { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    if (window.$ && window.$(".banner-slider").bxSlider) {
      window.$(".banner-slider").bxSlider({
        controls: false,
        pager: true,
        pagerCustom: ".bx-pager",
        minSlides: 5,
        maxSlides: 5,
        auto: true,
        pause: 4000,
      });
    }
  }, []);

  return (
    <>
      <div className="banners">
        <div id="banner">
          <ul className="banner-slider">
            <li>
              <div className="image__wrap">
                <img alt="" src="../img/banner/main_banner1.jpg" />
              </div>
              <div className="text__wrap">A SPEC</div>
            </li>
            <li>
              <div className="image__wrap">
                <img alt="" src="../img/banner/main_banner2.jpg" />
              </div>
              <div className="text__wrap">A SPEC</div>
            </li>
            <li>
              <div className="image__wrap">
                <img alt="" src="../img/banner/main_banner3.jpg" />
              </div>
              <div className="text__wrap">A SPEC</div>
            </li>
            <li>
              <div className="image__wrap">
                <img alt="" src="../img/banner/main_banner4.jpg" />
              </div>
              <div className="text__wrap">A SPEC</div>
            </li>
            <li>
              <div className="image__wrap">
                <img alt="" src="../img/banner/main_banner5.jpg" />
              </div>
              <div className="text__wrap">A SPEC</div>
            </li>
          </ul>
          <div className="bx-pager">
            <div className="bx-pager-item">
              <a className="bx-pager-link" data-slide-index="0" href="#"><span></span></a>
            </div>
            <div className="bx-pager-item">
              <a className="bx-pager-link" data-slide-index="1" href="#"><span></span></a>
            </div>
            <div className="bx-pager-item">
              <a className="bx-pager-link" data-slide-index="2" href="#"><span></span></a>
            </div>
            <div className="bx-pager-item">
              <a className="bx-pager-link" data-slide-index="3" href="#"><span></span></a>
            </div>
            <div className="bx-pager-item">
              <a className="bx-pager-link" data-slide-index="4" href="#"><span></span></a>
            </div>
          </div>
        </div>
        <div className="brand">
          <div className="container-1400">
            <span>(주)에이스펙</span>
          </div>
        </div>
      </div>
      <div className="main">
        <div className="bg">
          <div className="container-1400">
            <div className="main__wrap">
              <div className="contl">
                <h2>
                  BUSINESS<br />
                  AREA
                </h2>
                <div className="desc">
                  반도체 플랜트 배관 · 랙 제작, 자동화장비 제작, 모빌리티 제작,<br />
                  자율주행 인터페이스 제작 및 각 분야 맞춤 전문 기업<br />
                  (주)에이스펙입니다.
                </div>
              </div>
              <div className="contr">
                <div className="cont__row">
                  <div className="cont__col">
                    <div className="box__img">
                      <img alt="" src="../img/main/main_section1_1.jpg" />
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/business/semiconductor')}>
                      <p>
                        <span>01</span><br />
                        SEMICONDUCTOR<br />
                        PLUMBING
                      </p>
                    </div>
                  </div>
                  <div className="cont__col">
                    <div className="box__img">
                      <img alt="" src="../img/main/main_section1_2.jpg" />
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/business/automation')}>
                      <p>
                        <span>02</span><br />
                        AUTOMATED<br />
                        EQUIPMENT
                      </p>
                    </div>
                  </div>
                </div>
                <div className="cont__row">
                  <div className="cont__col">
                    <div className="box__img">
                      <img alt="" src="../img/main/main_section1_3.jpg" />
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/business/mobility')}>
                      <p>
                        <span>03</span><br />
                        MOBILITY
                      </p>
                    </div>
                  </div>
                  <div className="cont__col">
                    <div className="box__img">
                      <img alt="" src="../img/main/main_section1_4.jpg" />
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/business/automatic-driving')}>
                      <p>
                        <span>04</span><br />
                        AUTOMATIC<br />
                        DRIVING
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="main">
        <div className="bg">
          <div className="container-1400">
            <div className="main__wrap">
              <div className="contl">
                <h2>
                  ABOUT<br />
                  COMPANY
                </h2>
                <div className="desc">
                  창조적 열정과 변화를 선도하는 첨단 플랜트 산업 효율 개선 핵심 기업<br />
                  (주)에이스펙입니다.
                </div>
              </div>
              <div className="contr">
                <div className="cont__row">
                  <div className="cont__col">
                    <div className="box__img">
                      <img alt="" src="../img/main/main_section2_1.png" />
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/introduce/summary')}>
                      <p>
                        COMPANY<br />
                        <span>회사소개</span>
                      </p>
                    </div>
                  </div>
                  <div className="cont__col">
                    <div className="box__img">
                      <img alt="" src="../img/main/main_section2_2.png" />
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/introduce/history')}>
                      <p>
                        HISTORY<br />
                        <span>연혁</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="cont__row">
                  <div className="cont__col">
                    <div className="box__img">
                      <img alt="" src="../img/main/main_section2_3.png" />
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/introduce/certificate')}>
                      <p>
                        CREDENTIALS<br />
                        <span>인증서</span>
                      </p>
                    </div>
                  </div>
                  <div className="cont__col">
                    <div className="box__img">
                      <img alt="" src="../img/main/main_section2_4.png" />
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/lab/automatic-factory')}>
                      <p>
                        IDEA FACTORY<br />
                        <span>부설연구소</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="main">
        <div className="bg ico">
          <div className="container-1400">
            <div className="main__wrap">
              <div className="contl">
                <h2>
                  A SPEC<br />
                  CUSTOMER CENTER
                </h2>
                <div className="desc">
                  최고의 기술과 최상의 고객만족을 위한 경쟁력으로 <br />
                  보답할 것을 약속 드립니다.
                </div>
              </div>
              <div className="contr">
                <div className="cont__row ico">
                  <div className="cont__col">
                    <div className="box__img">
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/result/gallery')}>
                      <img alt="" src="../img/main/main_ico_1.png" />
                      <p>
                        GALLERY<br />
                        <span>실적갤러리</span>
                      </p>
                    </div>
                  </div>
                  <div className="cont__col">
                    <div className="box__img">
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/result/major')}>
                      <img alt="" src="../img/main/main_ico_2.png" />
                      <p>
                        BUSINESS<br />
                        PERFORMANCE<br />
                        <span>주요실적</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="cont__row ico">
                  <div className="cont__col">
                    <div className="box__img">
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/introduce/factory')}>
                      <img alt="" src="../img/main/main_ico_3.png" />
                      <p>
                        LOCATION<br />
                        <span>공장소개</span>
                      </p>
                    </div>
                  </div>
                  <div className="cont__col">
                    <div className="box__img">
                    </div>
                    <div className="over__txt" onClick={() => (window.location.href = '/cs/mail')}>
                      <img alt="" src="../img/main/main_ico_4.png" />
                      <p>
                        INQULRY<br />
                        <span>대표메일</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
